var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImg7(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 78,
    viewBox: "0 0 64 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_165_120121)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0112 51.008L0 38.9968L39 0H63.0192M63.0192 35.9862H39L30.0027 44.9835L42.0138 56.9947",
    fill: "#42A5F5",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0024 69.0026L38.9998 78H63.0189L42.0136 56.9946",
    fill: "#0D47A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.02 57.001L30.0123 45.0056L42.0045 56.9979L30.0123 68.9932L18.02 57.001Z",
    fill: "#42A5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0122 68.9932L42.0044 57.001L43.6784 58.675L31.6862 70.6672L30.0122 68.9932Z",
    fill: "url(#paint0_linear_165_120121)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0024 69.0026L47.8237 62.8457L42.0136 56.9915",
    fill: "url(#paint1_linear_165_120121)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_165_120121",
    x1: 36.0106,
    y1: 62.9949,
    x2: 37.6847,
    y2: 64.669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#616161",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_165_120121",
    x1: 30.0067,
    y1: 62.9974,
    x2: 47.8277,
    y2: 62.9974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#616161",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_165_120121"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 63.0192,
    height: 78,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg7);
export default __webpack_public_path__ + "static/media/img7.7c709f8527726024b12a5e51283a62a0.svg";
export { ForwardRef as ReactComponent };